import React from 'react'
import { Provider } from "react-redux";
import { JitsuProvider } from "@jitsu/jitsu-react";
import { ConfigProvider } from "antd";

import LoginProvider from "../Contexts/LoginContext";
import NavBarProvider from "../Contexts/NavBarContext";
import NavListProvider from "../Contexts/navContext"
import CurrentContextProvider from "../Components/Kalyanlite/context/CurrentContactContext";


import configureStore from "../Store/main";
import config from "../config";
import App from "../App";

import '../i18n';
import "../index.css";

function MainApp() {
  return (
    <Provider store={configureStore({})}>
        <LoginProvider>
          <NavBarProvider>
            <NavListProvider>
              <CurrentContextProvider>
                <ConfigProvider theme={{
                  token: {
                    colorPrimary: "#D23C27"
                  }
                }}>
                  <JitsuProvider options={{
                    host: config.jitsuUrl,
                    writeKey: config.jitsuKey
                  }}>
                    <App />
                  </JitsuProvider>
                </ConfigProvider>
              </CurrentContextProvider>
            </NavListProvider>
          </NavBarProvider>
        </LoginProvider>
    </Provider>
  )
}

export default MainApp